import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('login', {
        template: require('./login.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;

        vm.data = {
            type: 'new_teacher'
        };

        vm.user = SessionService.getUser();
        vm.app = $stateParams.app;
        vm.specs = $stateParams.specs;
        vm.send_specs = send_specs;
        vm.app = 1;

        vm.border_tl = require('Images/bordertl.png');
        vm.border_tr = require('Images/bordertr.png');
        vm.border_bl = require('Images/borderbl.png');
        vm.border_br = require('Images/borderbr.png');
        vm.registered_img = require('Images/registered.png');


        if($stateParams.popup == '1'){
            logger.success('Succesfully created an account, Please log-in to proceed');
        }

        function proceed(){

            if(vm.app){
                $state.go('application-details', $stateParams);
            }else{
                window.location = '/#!/download_app';
            }
        }

        if(vm.user){

            if(vm.specs){

                setTimeout(()=>{
                    const specs = localStorage.getItem('specs');
                    console.log('data', specs);
                    vm.send_specs(specs);
                }, 100);

            }else{
                proceed();
            }
            
        }

        function send_specs(specs){

            var req = {
                method: 'PUT',
                body: { specs: specs }, 
                params: false, 
                hasFile: false, 
                route: { teacher: vm.user.id }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    proceed();
                });
        };

        vm.login = () => {

            var req = {
                method: 'POST',
                body: vm.data, 
                params: false, 
                hasFile: false, 
                route: { auth: 'sign-in-app' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    // console.log('kbjhsdfag',data)
                    SessionService.saveUser(data);
                    if(vm.app){
                        $state.go('application-details', $stateParams);
                    }else{
                        window.location = '/#!/download_app';
                    }
        
                })
                .catch(function(response) {
                    if (response.status == 400) {
                        var error = response.data.errors[0];

                        var context = error.message;
                        logger.error(context);

                    }
                });
        }

        vm.register = () => {

            var req = {
                method: 'POST',
                body: vm.data, 
                params: false, 
                hasFile: false, 
                route: { teacher: 'register-email' }, 
            };

            console.log(vm.data);

            QueryService.query(req)
                .then(function(response) {
                    console.log(response.data.errors)
                    if(response.data.errors && response.data.errors['DUPLICATE_FILE']){
                        logger.error('This email is already registered in our system. Please check your email for further details. ');
                    }else{
                        vm.registered = true;
                    }
                })
                .catch(function(response) {
                    if (response.status == 400) {
                        var error = response.data.errors[0];

                        var context = error.message;
                        logger.error(context);
                    }
                });
        }

        vm.can_apply = 1;
        vm.can_apply = 0;
        check_now();
        function check_now(){

            // var request = {
            //     method: 'GET',
            //     params: false,
            //     hasFile: false,
            //     route: { settings_application_dates: 'now' }
            // };

            // QueryService.query(request)
            //     .then(
            //         function(response) {
            //             const d = response.data.data.items;
            //             vm.can_apply = d.length != 0;

                        

            //         },
            //         function(error) {
            //         }
            //     )
            //     .finally(function() {
            //         vm.loaded_now = true;
            //     });
            
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { settings: 'hiring' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        if(parseInt(data.setting_data)){
                            vm.can_apply = true;
                        }
                        // console.log(data);
                        init_processes();
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }

        vm.cannot_register = () => {

            if(vm.data.username && !vm.data.username.includes('@gmail.com')){
                if(vm.data.username && vm.data.kakao_id){
                    return 'gmail'
                }
                return true;
            }

            return !vm.data.username || !vm.data.name || !vm.data.kakao_id;
        }

    }
})();


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.js